import { DataPoint } from "../backend/backendapi";

export class Selectable {
    text: string;
    value: string;

    constructor(text: string, value: string) {
        this.text = text;
        this.value = value;
    }
}

export class Series {
    server!: string;
    dbase!: string;
    table!: string;
    field!: string;
    start!: Date;
    end!: Date;
    data!: DataPoint[];
    color!: string;
    xpropname!: string;
    ypropname!: string;
    label!: string;
    unit!: string;
}
